export default "__VITE_ASSET__C6CpZ5tR__ 100w";